export const USER_REGISTRATION_DIALOG_HEADER =
  'user.registration.dialog.header';
export const USER_REGISTRATION_DIALOG_SUB_HEADER =
  'user.registration.dialog.sub.header';
export const USER_REGISTRATION_DIALOG_TEXT = 'user.registration.dialog.text';
export const USER_REGISTRATION_DIALOG_BUTTON =
  'user.registration.dialog.button';
export const USER_REGISTRATION_DIALOG_LISTEN_ALEXA =
  'user.registration.dialog.listen.alexa';
export const USER_REGISTRATION_DIALOG_LINK_ALEXA =
  'user.registration.dialog.link.alexa';
